<template>
  <div>
    <a-table
      class="top-table"
      size="small"
      rowKey="id"
      bordered
      :loading="loading"
      :columns="COLUMNS"
      :data-source="datas"
      :pagination="false"
    >
      <div slot="title" style="text-align: right;">
        <a-button
          type="primary"
          icon="plus"
          @click="
            () => {
              visible = true;
              item = {};
            }
          "
        >
          Add process user
        </a-button>
      </div>
      <span slot="no" slot-scope="text, record, index"> {{ index + 1 }} </span>
      <span slot="processUsers" slot-scope="text">
        <span v-for="i in text" :key="i.id">
          {{ i.fullname }} <small> ({{ i.email }}) </small> <br />
        </span>
      </span>

      <span slot="action" slot-scope="text, record">
        <a-button
          style="border: 0;"
          icon="edit"
          type="link"
          title="edit"
          @click="
            () => {
              setVisibleModal(record);
            }
          "
        >
        </a-button>
      </span>
    </a-table>
    <a-modal v-model="visible" title="Update process user" :footer="null">
      <AddEditItem
        :categoryId="categoryId"
        :close="setVisibleModal"
        :item="item"
        :refreshAfterCreated="refreshAfterCreated"
        :refreshAfterUpdated="refreshAfterUpdated"
      />
    </a-modal>
  </div>
</template>
<script>
import AddEditItem from "./add-edit-item";
import query from "./query.define";

const COLUMNS = [
  {
    title: "No.",
    key: "no",
    scopedSlots: { customRender: "no" },
    align: "center",
    width: 50,
  },
  {
    title: "Location",
    dataIndex: "branchLocation.name",
    width: 125,
  },
  {
    title: "Process users",
    dataIndex: "processUsers",
    scopedSlots: { customRender: "processUsers" },
    width: 250,
  },
  {
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "center",
    width: 50,
  },
];

const LIMIT = null;
const START_PAGE = 1;

export default {
  components: { AddEditItem },
  props: {
    categoryId: {
      type: String,
      required: true,
    },
    setProcessUsers: {
      type: Function,
      default: () => {},
    },
    setLoadingProcessUser: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      datas: [],
      COLUMNS,
      visible: false,
      loading: false,
      item: {},
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      this.loading = true;
      this.setLoadingProcessUser(true);
      try {
        this.datas = await this.getResultQuery();
        if (typeof this.setProcessUsers === "function") {
          this.setProcessUsers(this.datas);
        }
      } catch (err) {
        console.error("err", err);
        this.$notification.error({
          message: "Error",
          description: "Get error!",
        });
      }
      this.setLoadingProcessUser(false);
      this.loading = false;
    },
    async getResultQuery() {
      const result = await this.$apollo.query({
        query: query.getListHelpdeskProcessUser,
        fetchPolicy: "no-cache",
        variables: {
          LIMIT,
          page: START_PAGE,
          categoryIds: [this.categoryId],
        },
      });

      return result?.data?.getListHelpdeskProcessUser?.length > 0
        ? [...result.data.getListHelpdeskProcessUser]
        : [];
    },
    setVisibleModal(item) {
      if (item) {
        this.item = {
          ...item,
          processUserIds:
            item.processUsers?.length > 0
              ? item.processUsers.map((e) => e.id)
              : null,
        };
        this.visible = true;
      } else {
        this.item = {};
        this.visible = false;
      }
    },
    refreshAfterCreated(item = {}) {
      this.datas.unshift(item);
    },
    refreshAfterUpdated(item = {}) {
      const findIndex = this.datas.findIndex((e) => e.id === item.id);
      findIndex >= 0
        ? this.$set(this.datas, findIndex, {
            ...this.datas[findIndex],
            ...item,
          })
        : "";
    },
  },
};
</script>
